export const IdentificadorJson = {
    JSON_CAMPO_CODIGO_COLABORADOR : "CODIGO" ,
    JSON_CAMPO_NRO_DOCUMENTO: "DOCUMENTO_IDENTIDAD"
};